const faqItems = document.querySelectorAll('.faq__item');
const faqNavs = document.querySelectorAll('.faq-navigation-list a');
const faqTitle = document.querySelector('.faq__wrapper h2');
const faqSelect = document.querySelector('.faq-select');

function updateFAQItems(selectedId, textContent) {
    faqTitle.textContent = textContent;     

    faqItems?.forEach(item => {
        item.setAttribute('is-hidden', true);
        item.querySelector('.collapsible-toggle').setAttribute('aria-expanded', false);
    });

    if( selectedId !== "category-default") {
    const categoryDevider = document.getElementById(selectedId);
    if (categoryDevider) {
        let sibling = categoryDevider.nextElementSibling;
        while (sibling && sibling.tagName.toLowerCase() !== 'span') {
            if (sibling.classList.contains('faq__item')) {
                sibling.removeAttribute('is-hidden');
            }
            sibling = sibling.nextElementSibling;
        }
    }
    }else{
        faqItems?.forEach(item => { 
            item.hasAttribute('is-faq') ? item.removeAttribute('is-hidden') : item.setAttribute('is-hidden', true);
        });
    }
}

faqNavs?.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();
        const categoryId = this.getAttribute('href').substring(1);
        const categoryText = this.textContent || "";
        updateFAQItems(categoryId, categoryText);
    });
});

faqSelect.addEventListener('change', function() {
    const selectedId = this.value;
    const valueText = this.options[this.selectedIndex].textContent || "";
    updateFAQItems(selectedId, valueText);
   
});
